import type { NskResponse } from '~/models/Api';
import { postRequest, putRequest } from '~/utils/api/api_handler';
import type {
  VendorCompanyUpdateSelfParams,
  VendorCompanyUpdatePasswordParam
} from '~/models/VendorCompany';

const paths = {
  updateSelf: '/vendors/vendor_companies/update_self',
  changePassword: '/vendors/vendor_companies/change_password'
};

export const updateSelf = async (
  vendorCompany: VendorCompanyUpdateSelfParams
): Promise<NskResponse<void>> =>
  putRequest(paths.updateSelf, { vendorCompany });

export const changePassword = async (
  passwords: VendorCompanyUpdatePasswordParam
): Promise<NskResponse<void>> => postRequest(paths.changePassword, passwords);
